import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import {
    BABOOR_ENVIRONMENT,
    BaboorEnvironmentConfig,
} from '@baboor/baboor-core'
import { ApiResponse } from '@baboor/common-models'
import { Observable } from 'rxjs'

export interface BusinessHour {
    id: string
    organizationId: string
    day: string
    isOpen: boolean
    openingTime: string
    closingTime: string
    createdAt: string | null
    updatedAt: string | null
}

export interface BusinessHourInput {
    day: string
    isOpen: boolean
    openingTime: string
    closingTime: string
}

@Injectable({ providedIn: 'root' })
export class BusinessHoursApiService {
    private baseUrl: string

    constructor(
        private http: HttpClient,
        @Inject(BABOOR_ENVIRONMENT) private env: BaboorEnvironmentConfig,
    ) {
        this.baseUrl = `${env.apiUrl}/v1/business-hours`
    }

    getBusinessHours(): Observable<ApiResponse<BusinessHour[]>> {
        return this.http.get<ApiResponse<BusinessHour[]>>(this.baseUrl)
    }

    updateBusinessHours(
        businessHours: BusinessHourInput[],
    ): Observable<ApiResponse<BusinessHour[]>> {
        return this.http.put<ApiResponse<BusinessHour[]>>(this.baseUrl, {
            businessHours,
        })
    }
}
